var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "case-animation-con" },
    [
      _c("div", { staticClass: "rolling-box" }, [
        _c(
          "div",
          { ref: "scroll", staticClass: "rolling-scroll" },
          _vm._l(_vm.virtual_case_awards, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                ref: "roll_item_" + index,
                refInFor: true,
                staticClass: "rolling-item",
                class: "rarity" + item.rarity,
              },
              [
                _c("div", { staticClass: "blank-icon" }),
                _c("div", { staticClass: "itemimg" }, [
                  _c("img", {
                    attrs: { src: _vm._f("imgfilter")(item.itempic) },
                  }),
                ]),
                _c("c-svg", {
                  staticClass: "itembg",
                  attrs: { src: "itembg.svg", fill: "rgb(0, 0, 0,.2)" },
                }),
                _c("div", { staticClass: "item-name-con" }, [
                  _c("div", { staticClass: "item-name" }, [
                    _c("div", { staticClass: "weapon-name" }, [
                      _vm._v(_vm._s(_vm._f("GetItemName")(item.name))),
                    ]),
                    _c("div", { staticClass: "skin-name" }, [
                      _vm._v(_vm._s(_vm._f("GetItemSkinName")(item.name))),
                    ]),
                  ]),
                  _c("div", { staticClass: "block" }),
                ]),
              ],
              1
            )
          }),
          0
        ),
        _c("div", { staticClass: "mask left" }),
        _c("div", { staticClass: "mask right" }),
      ]),
      _c("div", { ref: "hitline", staticClass: "arrow-1" }),
      _c("div", { staticClass: "arrow-2" }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }